export const getAPIBaseURL = () => {
  const fallbackApiBaseUrl = process.env.FRONTEND_TYPE === 'Customer' ? process.env.API_HOSTNAME_CUSTOMER || process.env.API_HOSTNAME : process.env.API_HOSTNAME

  if (process.env.FRONTEND_TYPE !== 'Customer' || typeof window === 'undefined') {
    return fallbackApiBaseUrl
  }

  const hostname = String(window.location.hostname || '')
    .trim()
    .toLowerCase()
  const port = String(window.location.port || '').trim()

  if (!hostname || hostname === 'localhost' || hostname.endsWith('.localhost') || hostname === '::1' || /^(\d{1,3}\.){3}\d{1,3}$/.test(hostname)) {
    return fallbackApiBaseUrl
  }

  if (port && !['80', '443'].includes(port)) {
    const apiHostname = hostname.startsWith('api.') ? hostname : `api.${hostname}`
    return `https://${apiHostname}:3000`
  }

  if (hostname === 'portal-staging.omninetworks.nl') {
    return 'https://api-staging.portal.omninetworks.nl'
  }

  return `https://api.${hostname}`
}
